import React from "react";
const Hero = () => {
  return (
    <section
      id="home"
      className="relative bg-gradient-to-r from-primary-600 to-primary-800 text-white py-20 overflow-hidden"
    >
      {" "}
      {/* Background with FASTag and Highway Theme */}{" "}
      <div className="absolute inset-0 overflow-hidden">
        {" "}
        {/* Highway Road Background */}{" "}
        <div className="absolute bottom-0 left-0 w-full h-64 bg-gradient-to-t from-neutral-800/30 to-transparent">
          {" "}
          <div className="absolute bottom-0 w-full h-40">
            {" "}
            {/* Road stripes animation */}{" "}
            <div className="highway-stripes"></div>{" "}
          </div>{" "}
        </div>{" "}
        {/* Toll Booth Arch Elements */}{" "}
        <div className="absolute top-0 left-1/4 w-32 h-48 border-4 border-white/10 rounded-b-full"></div>{" "}
        <div className="absolute top-0 right-1/4 w-32 h-48 border-4 border-white/10 rounded-b-full"></div>{" "}
        {/* FASTag Cards - Floating Background */}{" "}
        <div className="hidden md:block absolute top-10 left-10 w-40 h-24 bg-gradient-to-br from-purple-500/20 to-blue-500/20 rounded-lg transform rotate-12 animate-float shadow-2xl backdrop-blur-sm border border-white/10">
          {" "}
          <div className="p-3">
            {" "}
            <div className="text-xs font-bold opacity-70">SBI FASTag</div>{" "}
            <div className="text-xl font-bold mt-2">₹ 400</div>{" "}
          </div>{" "}
        </div>{" "}
        <div className="hidden md:block absolute top-40 right-20 w-44 h-28 bg-gradient-to-br from-orange-500/20 to-red-500/20 rounded-lg transform -rotate-6 animate-float-delayed shadow-2xl backdrop-blur-sm border border-white/10">
          {" "}
          <div className="p-3">
            {" "}
            <div className="text-xs font-bold opacity-70">IDFC FASTag</div>{" "}
            <div className="text-xl font-bold mt-2">Fast & Easy</div>{" "}
          </div>{" "}
        </div>{" "}
        <div className="absolute bottom-32 left-1/4 w-36 h-24 bg-gradient-to-br from-green-500/20 to-emerald-500/20 rounded-lg transform rotate-45 animate-float shadow-2xl backdrop-blur-sm border border-white/10">
          {" "}
          <div className="p-2 text-center">
            {" "}
            <div className="text-xs font-bold opacity-70">Cashless</div>{" "}
            <div className="text-lg font-bold mt-1">Toll</div>{" "}
          </div>{" "}
        </div>{" "}
        {/* Vehicle Silhouettes */}{" "}
        <div className="absolute top-1/4 left-10 animate-float opacity-15">
          {" "}
          <svg className="w-20 h-20" fill="white" viewBox="0 0 24 24">
            {" "}
            <path d="M18.92 6.01C18.72 5.42 18.16 5 17.5 5h-11c-.66 0-1.21.42-1.42 1.01L3 12v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.5 16c-.83 0-1.5-.67-1.5-1.5S5.67 13 6.5 13s1.5.67 1.5 1.5S7.33 16 6.5 16zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5 11l1.5-4.5h11L19 11H5z" />{" "}
          </svg>{" "}
        </div>{" "}
        <div className="absolute top-1/3 right-16 animate-float-delayed opacity-15">
          {" "}
          <svg className="w-24 h-24" fill="white" viewBox="0 0 24 24">
            {" "}
            <path d="M20 8h-3V4H3c-1.1 0-2 .9-2 2v11h2c0 1.66 1.34 3 3 3s3-1.34 3-3h6c0 1.66 1.34 3 3 3s3-1.34 3-3h2v-5l-3-4zM6 18.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm13.5-9l1.96 2.5H17V9.5h2.5zm-1.5 9c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z" />{" "}
          </svg>{" "}
        </div>{" "}
        {/* RFID Signal Waves */}{" "}
        <div className="absolute bottom-1/4 left-1/2 transform -translate-x-1/2">
          {" "}
          <div className="relative w-24 h-24">
            {" "}
            <div className="absolute inset-0 border-4 border-white/20 rounded-full animate-ping"></div>{" "}
            <div className="absolute inset-4 border-4 border-white/30 rounded-full animate-pulse"></div>{" "}
            <div className="absolute inset-8 bg-white/40 rounded-full flex items-center justify-center">
              {" "}
              <svg className="w-8 h-8" fill="white" viewBox="0 0 24 24">
                {" "}
                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />{" "}
              </svg>{" "}
            </div>{" "}
          </div>{" "}
        </div>{" "}
        {/* Indian Flag Colors Accent */}{" "}
        <div className="absolute top-0 right-0 w-1 h-full bg-gradient-to-b from-orange-500/30 via-white/30 to-green-500/30"></div>{" "}
      </div>{" "}
      <div className="container mx-auto px-4 relative z-10">
        {" "}
        <div className="max-w-4xl mx-auto text-center">
          {" "}
          <h1 className="text-4xl md:text-5xl font-bold mb-6 drop-shadow-lg">
            {" "}
            Fast, Reliable FASTag Solutions for Every Road Ahead{" "}
          </h1>{" "}
          <p className="text-xl md:text-2xl mb-8 text-primary-100 drop-shadow-md">
            {" "}
            Official SBI & IDFC FASTag Partner for Agents & Vehicle Owners{" "}
          </p>{" "}
          <div className="flex flex-col sm:flex-row justify-center gap-4 mb-12">
            {" "}
            <a
              href="#customer-form"
              className="bg-white text-primary-600 px-8 py-4 rounded-lg font-semibold hover:bg-primary-50 transition shadow-lg"
            >
              {" "}
              Get Your FASTag Now{" "}
            </a>{" "}
            <a
              href="#agent-form"
              className="bg-transparent border-2 border-white text-white px-8 py-4 rounded-lg font-semibold hover:bg-white hover:text-primary-600 transition"
            >
              {" "}
              Become an Agent{" "}
            </a>{" "}
          </div>{" "}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-12">
            {" "}
            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6">
              {" "}
              <div className="text-3xl mb-2">🏦</div>{" "}
              <h3 className="font-semibold mb-2">Official Bank Partner</h3>{" "}
              <p className="text-sm text-primary-100">
                SBI & IDFC First Bank Authorized
              </p>{" "}
            </div>{" "}
            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6">
              {" "}
              <div className="text-3xl mb-2">🚚</div>{" "}
              <h3 className="font-semibold mb-2">Doorstep Delivery</h3>{" "}
              <p className="text-sm text-primary-100">
                100% Online & Paperless Process
              </p>{" "}
            </div>{" "}
            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6">
              {" "}
              <div className="text-3xl mb-2">⏰</div>{" "}
              <h3 className="font-semibold mb-2">24/7 Support</h3>{" "}
              <p className="text-sm text-primary-100">
                Dedicated Query Resolution
              </p>{" "}
            </div>{" "}
          </div>{" "}
        </div>{" "}
      </div>{" "}
    </section>
  );
};
export default Hero;
